import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, Col, Row, Statistic, Skeleton } from 'antd';

import config from '../../../settings/config.json';
import { formatDate } from '../../../functions/formatDate';

function Admin_Statistic() {
  const [listeners, setListeners] = useState(0);
  const [startServer, setStartServer] = useState('Loading...');
  const [weeklyVisits, setWeeklyVisits] = useState(0);

  useEffect(() => {
    const fetchCurrentTrack = async () => {
      try {
        const response = await axios.get(`/player/status`);
        const source = response.data.icestats.source;
        const start_time = response.data.icestats.server_start;

        const listeners = Array.isArray(source) ? source[0].listeners : source.listeners;
        const dateStr = Array.isArray(source) ? start_time : start_time;
        const start = formatDate(dateStr);

        setListeners(listeners);
        setStartServer(start);
      } catch (error) {
        console.error('ERROR:', error);
      }
    };

    const fetchWeeklyVisits = async () => {
      try {
        const response = await axios.get(`/api/weekly-visits`);
        setWeeklyVisits(response.data.visits);
      } catch (error) {
        console.error('ERROR:', error);
      }
    };

    fetchCurrentTrack();
    fetchWeeklyVisits();

    const interval = setInterval(() => {
      fetchCurrentTrack();
      fetchWeeklyVisits();
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className='Statistic'>
        <Row gutter={16}>
            <Col span={8}>
                <Card bordered={false} className='bg-black'>
                    <Statistic 
                        title={
                        <span style={{ 
                            color: '#AEAEAE', 
                            fontFamily: 'Kanit, sans-serif', 
                            fontSize: '24px' 
                        }}>
                        Dinləyicilər
                        </span>} 
                        value={listeners} 
                        valueStyle={{ 
                            color: 'white', 
                            fontFamily: 'Kanitb, sans-serif', 
                            fontSize: '36px' 
                        }}
                        prefix={
                            <i className="fa-solid fa-ear-listen text-gradient"></i>
                        } 
                    />
                </Card>
            </Col>

            <Col span={8}>
                <Card bordered={false} className='bg-black'>
                    <Statistic 
                        title={
                        <span style={{ 
                            color: '#AEAEAE', 
                            fontFamily: 'Kanit, sans-serif', 
                            fontSize: '24px' 
                        }}>
                        Başlayın
                        </span>} 
                        value={startServer} 
                        valueStyle={{ 
                            color: 'white', 
                            fontFamily: 'Kanitb, sans-serif', 
                            fontSize: '36px' 
                        }}
                        prefix={
                            <i className="fa-solid fa-hourglass-start text-gradient-two"></i>
                        } 
                    />
                </Card>
            </Col>

            <Col span={8}>
                <Card bordered={false} className='bg-black'>
                    <Statistic 
                        title={
                        <span style={{ 
                            color: '#AEAEAE', 
                            fontFamily: 'Kanit, sans-serif', 
                            fontSize: '24px' 
                        }}>
                        Ziyarətlər bu həftə
                        </span>} 
                        value={weeklyVisits} 
                        valueStyle={{ 
                            color: 'white', 
                            fontFamily: 'Kanitb, sans-serif', 
                            fontSize: '36px' 
                        }}
                        prefix={
                            <i className="fa-solid fa-calendar-week text-gradient-two"></i>
                        } 
                    />
                </Card>
            </Col>
        </Row>
    </div>
  );
}

export default Admin_Statistic;